package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdIncludedBand
import com.anjuros.website.redesign.components.RdIncludedItem
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

private val IncludedItems = listOf(
    RdIncludedItem({ RdIcons.Phone() }, RdText.HOME_INCLUDED_MOBILE, RdText.HOME_INCLUDED_MOBILE_TEXT),
    RdIncludedItem({ RdIcons.Search() }, RdText.HOME_INCLUDED_SEO, RdText.HOME_INCLUDED_SEO_TEXT),
    RdIncludedItem({ RdIcons.Globe() }, RdText.HOME_INCLUDED_DOMAIN, RdText.HOME_INCLUDED_DOMAIN_TEXT),
    RdIncludedItem({ RdIcons.Lock() }, RdText.HOME_INCLUDED_HOSTING, RdText.HOME_INCLUDED_HOSTING_TEXT),
    RdIncludedItem({ RdIcons.Mail() }, RdText.HOME_INCLUDED_FORM, RdText.HOME_INCLUDED_FORM_TEXT, RdRoute.CONTACT_FORMS),
)

/** Between the hero and the designs: what every website comes with. */
@Composable
fun HomeIncludedSection() {
    RdIncludedBand(RdText.HOME_INCLUDED_TITLE, IncludedItems)
}
